<template>
<el-row class="cs-contentContainer cs-wechatRe-content" v-loading="isLoading">
    <el-col>
      <el-row class="cs-wechatRe-item" v-if="!isSuccess">
        <el-col>
          <span>速成学员账号:</span>
          <span>{{studentName}}</span>
        </el-col>
      </el-row>
      <el-row class="cs-wechatRe-item cs-wechatRe-success" v-if="isSuccess">
        <el-col>
          <el-row class="cs-wechatRe-success-item">
            <el-col> <img src="../assets/success.png" /></el-col>
          </el-row>
          <el-row class="cs-wechatRe-success-item">
            <el-col> <span>确认成功！</span></el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col> 
</el-row>
  
</template>

<style lang="scss" scoped>
.cs-wechatRe-content{
   margin: auto;
   display: table;
  .cs-wechatRe-item{
    margin-top: 10px;
    line-height: 20px;
    font-size: 16px;


  }
  .cs-wechatRe-success{
    text-align: center;
    margin-top: 20px;
    img{
      height: 85px;
      margin-bottom: 10px;
    }
  }
}

</style>

<script>
import { validateWechatUser } from "../service/user.service";
import { getStore, setStore } from '../config/mUtils';

export default {
  props: {
    
  },
  data() {
    return {
      isBinding: false,
      isSuccess: false,
      isLoading: false,
      action: ""
    };
  },
  created() {
   
    let data = this.$route.query.data;
    if (!!data){
      let result = JSON.parse(data);
      this.action = result.action;
      if (result.success){
        this.validateUser(result);
      }else{
        this.$message.error(result.message);
      }
    }
    
    this.studentName = getStore("user_name");
    
  },
  methods: {
    validateUser(data){
      this.isLoading = true;
      validateWechatUser(data.code).then(result =>{
        if (!!result && result.success){
          this.isSuccess = true;
          this.sendMsg(true, "");
        }else{
          this.sendMsg(false, result.message);
        }
        this.isLoading = false;
      }).catch(()=>{
        this.isLoading = false;
      });
    },
    sendMsg(success, message){
      window.parent.postMessage({
        cmd: this.action,
        params: {
          success: success,
          message: message
        }
      }, '*');
    }
  },
  watch: {
   
  }
};
</script>



// WEBPACK FOOTER //
// src/page/wechatResponse.vue